module.exports = __webpack_public_path__ + "img/euro_normal_audi.bc41210f.svg";